import { useState, useEffect, useContext, useCallback } from 'react';
import {useNavigate} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Stack, Button, Card, Alert, Box } from '@mui/material';
// components
import Iconify from '../components/iconify';

import { EntityContext } from '../entity';
import { AccountContext } from '../account';
import { openSupportWhatsApp } from '../utils/constants';

import AppWidgetSummary from '../sections/@dashboard/app/AppWidgetSummary'

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [token, setToken] = useState(null)
  const [currentEntity, setCurrentEntity] = useState(null)
  const [userInfo, setUserInfo] = useState(null)
  const [showStorageAlert, setShowStorageAlert] = useState(false)
  const [alertSeverity, setAlertSeverity] = useState('warning')
  const [alertMessage, setAlertMessage] = useState('')

  const { getEntity, getEntities } = useContext(EntityContext)
  const { getSession } = useContext(AccountContext)

  useEffect(() => {
    getSession()
        .then((data) => {
            setToken(data.idToken.jwtToken)
        })
    }, [])

  useEffect(() => {
    getCurrentEntity()
    GetUserInfo()
    }, [token])

  useEffect(() => {
    checkStorageUsage()
  }, [currentEntity])

  const checkStorageUsage = () => {
    if (currentEntity && currentEntity.info && currentEntity.info.storage_consumption) {
      const storageUsed = parseFloat(currentEntity.info.storage_consumption)
      const maxStorage = 10 // 10GB franquia
      const percentage = (storageUsed / maxStorage) * 100

      if (percentage >= 80) {
        setShowStorageAlert(true)
        
        if (percentage >= 90) {
          setAlertSeverity('error')
          setAlertMessage(`ATENÇÃO: Você está próximo do limite da sua franquia (${percentage.toFixed(1)}%). Entre em contato imediatamente com um representante.`)
        } else {
          setAlertSeverity('warning')
          setAlertMessage(`Você atingiu ${percentage.toFixed(1)}% da sua franquia de armazenamento. Considere entrar em contato com um representante.`)
        }
      } else {
        setShowStorageAlert(false)
      }
    }
  }

    const GetUserInfo = useCallback(async () => {

      handleSetUserInfo(token)

    }, [token])

  const handleSetUserInfo = async (token) => {
    getEntities(token)
      .then(data => {
        
        setUserInfo(data.user)
      })
  }

    const getCurrentEntity = useCallback(async () => {
	
      getEntity()
          .then((data) => {
            
            setCurrentEntity(data.entity)
          })
              
        }, [])

  const navigateToNewEnvelope = () => {
    // 👇️ navigate to /contacts
    navigate('/dashboard/envelope');
  };

  const navigateToEnvelopes = () => {
    // 👇️ navigate to /contacts
    navigate('/dashboard/envelopes');
  };

  const navigateToPendingSignatures = () => {
    // 👇️ navigate to /contacts
    navigate('/dashboard/pendingSignatures');
  };

  const handleCloseAlert = () => {
    setShowStorageAlert(false)
  }

  return (
    <>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>

      <Container maxWidth="xl">

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
            Dashboard
            </Typography>
            { currentEntity ? 
              <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={navigateToNewEnvelope}>
                Novo Envelope
              </Button> :
              <></> }
        </Stack>

        {showStorageAlert && (
          <Box mb={3}>
            <Alert 
              severity={alertSeverity} 
              onClose={handleCloseAlert}
              action={
                <Button 
                  color="inherit" 
                  size="small"
                  onClick={openSupportWhatsApp}
                >
                  Contatar Representante
                </Button>
              }
            >
              {alertMessage}
            </Alert>
          </Box>
        )}
        
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              link={navigateToEnvelopes}
              title="Espaço Ultilizado (GB)"
              total={currentEntity ? `${currentEntity.info.storage_consumption}` : `0`}
              maximum={currentEntity ? `10.00` : `0`}
              icon="mdi:database"
            />
          </Grid>  
          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              link={navigateToEnvelopes}
              title="Pontos Usados Este Mês"
              total={currentEntity ? `${currentEntity.info.envelopes_this_month}` : `0`}
              maximum={currentEntity ? `${currentEntity.plan.envelope_cost.monthly_maximum}` : `0`}
              color="success"
              icon="mdi:email-multiple"
            />
          </Grid> 
          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              link={navigateToPendingSignatures}
              title="Assinaturas Pendentes"
              total={userInfo ? `${(userInfo.pending_signatures_count || 0) + (userInfo.pending_batch_signatures_count || 0)}` : `0` }
              color="warning"
              icon="mdi:pen"
            />
          </Grid> 
        </Grid>   
      </Container>
    </>
  );
}
